import axios from 'axios/index'

const namespaced = true

const state = {
  consignments: null,
  newConsignmentId: null,
  arrOfIcons: {
    zip: 'fas fa-file-archive',
    '7z': 'fas fa-file-archive',
    rar: 'fas fa-file-archive',
    pdf: 'fas fa-file-pdf',
    tif: 'fas fa-file-image',
    txt: 'fas fa-file-alt',
    rtf: 'fas fa-file-alt',
    doc: 'fas fa-file-word',
    docx: 'fas fa-file-word',
    jpg: 'fas fa-file-image',
    jpeg: 'fas fa-file-image',
    png: 'fas fa-file-image',
    gif: 'fas fa-file-image',
    xls: 'fas fa-file-excel',
    xlsx: 'fas fa-file-excel',
    csv: 'fas fa-file-csv',
    js: 'fas fa-file-code',
    css: 'fas fa-file-code',
    html: 'fas fa-file-code',
    xml: 'fas fa-file-code',
    xsl: 'fas fa-file-code',
    xslt: 'fas fa-file-code',
    ppt: 'fas fa-file-powerpoint',
    pptx: 'fas fa-file-powerpoint',
    pps: 'fas fa-file-powerpoint'
  }
}

const actions = {
  loadConsignments ({ commit, state }) {
    const url = '/api/private/v3.0/consignments/'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => response.data)
        .then(consignments => {
          commit('parseConsignments', consignments)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createConsignment ({ commit, state }, payload) {
    const url = '/api/private/v3.0/consignments/'
    const info = { info: payload }
    return new Promise((resolve, reject) => {
      axios.post(url, info)
        .then(response => response.data)
        .then(consignment => {
          commit('parseConsignment', consignment)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addFilesToNewConsignment ({ commit, state }, files) {
    const url = '/api/private/v3.0/consignments/' + state.newConsignmentId + '/files/'
    return new Promise((resolve, reject) => {
      for (let i = 0; i < files.length; i++) {
        const formData = new FormData()
        formData.append('file', files[i].file)
        axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => response.data)
          .then(res => {
            if (i === files.length - 1) {
              resolve('result')
            }
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  },
  addFilesToEditedConsignment ({ commit, state }, payload) {
    console.log(payload)
    const url = '/api/private/v3.0/consignments/' + payload.id + '/files/'
    return new Promise((resolve, reject) => {
      if (payload.files && payload.files.length > 0) {
        for (let i = 0; i < payload.files.length; i++) {
          const formData = new FormData()
          formData.append('file', payload.files[i].file)
          axios.post(url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(response => response.data)
            .then(res => {
              if (i === payload.files.length - 1) {
                resolve('result')
              }
            })
            .catch(error => {
              reject(error)
            })
        }
      } else {
        resolve('result')
      }
    })
  },
  editConsignment ({ commit, state }, payload) {
    const url = '/api/private/v3.0/consignments/' + payload.id + '/'
    return new Promise((resolve, reject) => {
      axios.patch(url, { info: payload.info })
        .then(res => {
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteFiles ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      for (let i = 0; i < payload.filesToDelete.length; i++) {
        const url = '/api/private/v3.0/consignments/' + payload.id + '/files/' + payload.filesToDelete[i] + '/'
        axios.delete(url, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then(response => response.data)
          .then(res => {
            if (i === payload.filesToDelete.length - 1) {
              resolve('result')
            }
          })
          .catch(error => {
            reject(error)
          })
      }
    })
  },
  piportalUploadConsignment ({ commit, state }, payload) {
    const url = '/api/private/v3.0/consignments/' + payload.id + '/piportal-upload/'
    axios.post(url, { server_alias: 'afbpp' })
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  }
}

const mutations = {
  parseConsignments (state, value) {
    for (let i = 0; i < value.length; i++) {
      value[i].actions = { visible: false }
      if (value[i].files && value[i].files.length) {
        for (let q = 0; q < value[i].files.length; q++) {
          value[i].files[q].icon = ''
          let ext = ''
          const parts = value[i].files[q].name.split('.')
          if (parts.length > 1) ext = parts.pop()
          for (const key in state.arrOfIcons) {
            if (ext.toLowerCase().indexOf(key) !== -1) {
              value[i].files[q].icon = state.arrOfIcons[key]
              break
            }
          }
          if (value[i].files[q].icon === '') {
            value[i].files[q].icon = 'fas fa-file'
          }
        }
      }
    }
    state.consignments = value
  },
  parseConsignment (state, value) {
    state.newConsignmentId = value.id
  },
  changeAttachmentsVisibility (state, value) {
    for (let i = 0; i < state.consignments.length; i++) {
      if (state.consignments[i].id === value) {
        state.consignments[i].showFiles = !state.consignments[i].showFiles
      }
    }
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
